import { useState, useEffect } from 'react';
import TeamService from '../views/Team/service';

export function useGetTeamsFiltered() {
  const [teams, setTeams] = useState([]);

  useEffect(() => {
    TeamService.getAllFilterTeam()
      .then((response) => {
        setTeams(response.data.data);
      })
      .catch((err) => {
        console.log('err: ' + err);
      });
  }, []);

  return {
    teams,
    setTeams
  };
}
